import * as React from 'react';
import { Route } from 'react-router-dom';

import { fetchJson } from "../BackendApi";
import LoadingIndicator from "../components/LoadingIndicator";
// import LocationsController from '../controllers/LocationsController';
import LocationsDrawerController from "../controllers/LocationsDrawerController";

export default function LocationsPage(props) {
    const { currentLanguage } = props;
    const [locations, setLocations] = React.useState(null);

    async function loadLocations() {
        const locations = await fetchJson(`/api/places?order%5Bname%5D=asc`);
        setLocations(locations);
    }

    React.useEffect(() => {
        loadLocations();
    }, []);

    if (!locations) {
        return <LoadingIndicator />;
    }

    return (
        // <LocationsController locations={locations} />
        <Route path={["/:id/:city", "/:id", "/"]}>
            <LocationsDrawerController locations={locations} currentLanguage={currentLanguage} />
        </Route>
    );
}